export interface Material {
  id: string;
  title: string;
  type: 'PDF' | 'PPT' | 'Video';
  pptType?: 'training' | 'promo';
  /** 一级分类 ID，对应 categoryTree 中的 primary category */
  primaryCategory: string;
  /** 二级分类（产品线大类，如 CT Systems） */
  category: string;
  /** 三级分类（产品型号，如 InsitumCT 338），权限授权颗粒度 */
  modelCategory?: string;
  thumbnail: string;
  tags: string[];
  uploadDate: string;
  fileSize: string;
  downloadAllowed: boolean;
  popular: boolean;
  views: number;
  isVideo?: boolean;
  videoDuration?: string;
  videoUrl?: string;
}

export const mockMaterials: Material[] = [
  {
    id: 'v1',
    title: 'InsitumCT 338 Product Overview & Key Features',
    type: 'Video',
    primaryCategory: 'training',
    category: 'E-learning',
    thumbnail: '',
    tags: ['Video', 'CT Systems', 'Product Overview'],
    uploadDate: '2026-02-18',
    fileSize: '245 MB',
    downloadAllowed: false,
    popular: true,
    views: 3420,
    isVideo: true,
    videoDuration: '18:42',
    videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 'v2',
    title: 'AlphaCT 868 Clinical Application Training — Module 1',
    type: 'Video',
    primaryCategory: 'training',
    category: 'E-learning',
    thumbnail: '',
    tags: ['Video', 'AlphaCT', 'Clinical Training'],
    uploadDate: '2026-01-22',
    fileSize: '312 MB',
    downloadAllowed: false,
    popular: true,
    views: 2876,
    isVideo: true,
    videoDuration: '24:15',
    videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 'v3',
    title: 'SinoCloud Platform Walkthrough for Distributors',
    type: 'Video',
    primaryCategory: 'training',
    category: 'E-learning',
    thumbnail: '',
    tags: ['Video', 'SinoCloud', 'Software Training'],
    uploadDate: '2025-11-10',
    fileSize: '198 MB',
    downloadAllowed: false,
    popular: false,
    views: 1654,
    isVideo: true,
    videoDuration: '31:08',
    videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 'v4',
    title: 'Mobile CT Deployment & Setup Guide',
    type: 'Video',
    primaryCategory: 'training',
    category: 'E-learning',
    thumbnail: '',
    tags: ['Video', 'Mobile CT', 'Setup'],
    uploadDate: '2025-09-05',
    fileSize: '276 MB',
    downloadAllowed: false,
    popular: false,
    views: 1102,
    isVideo: true,
    videoDuration: '22:30',
    videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: 'v5',
    title: 'Robot Navigation CT — Interventional Procedure Training',
    type: 'Video',
    primaryCategory: 'training',
    category: 'E-learning',
    thumbnail: '',
    tags: ['Video', 'Robot Navigation', 'Interventional'],
    uploadDate: '2025-07-14',
    fileSize: '389 MB',
    downloadAllowed: false,
    popular: true,
    views: 2341,
    isVideo: true,
    videoDuration: '45:20',
    videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
  },
  {
    id: '1',
    title: 'InsitumCT 338 Product Brochure 2024',
    type: 'PDF',
    primaryCategory: 'products',
    category: 'CT Systems',
    modelCategory: 'InsitumCT 338',
    thumbnail: '',
    tags: ['CT', 'InsitumCT', 'Brochure'],
    uploadDate: '2026-01-15',
    fileSize: '8.4 MB',
    downloadAllowed: true,
    popular: true,
    views: 1240,
  },
  {
    id: '2',
    title: 'AlphaCT 868 Technical Specifications Sheet',
    type: 'PDF',
    primaryCategory: 'products',
    category: 'CT Systems',
    modelCategory: 'AlphaCT 868',
    thumbnail: '',
    tags: ['CT', 'AlphaCT', 'Specs'],
    uploadDate: '2025-12-08',
    fileSize: '3.2 MB',
    downloadAllowed: true,
    popular: false,
    views: 876,
  },
  {
    id: '3',
    title: 'SinoCloud Platform Training Slides (PDF)',
    type: 'PPT',
    pptType: 'training',
    primaryCategory: 'software',
    category: 'Software',
    thumbnail: '',
    tags: ['Cloud', 'Software', 'Training'],
    uploadDate: '2025-12-20',
    fileSize: '12.7 MB',
    downloadAllowed: false,
    popular: true,
    views: 2103,
  },
  {
    id: '4',
    title: 'InsitumCT 64S Operation Manual v2.1',
    type: 'PDF',
    primaryCategory: 'products',
    category: 'CT Systems',
    modelCategory: 'InsitumCT 64S',
    thumbnail: '',
    tags: ['CT', 'Manual', 'Operation'],
    uploadDate: '2025-08-30',
    fileSize: '24.1 MB',
    downloadAllowed: true,
    popular: false,
    views: 654,
  },
  {
    id: '5',
    title: 'PACS Integration Guide for Distributors',
    type: 'PDF',
    primaryCategory: 'software',
    category: 'Software',
    thumbnail: '',
    tags: ['PACS', 'Integration', 'Software'],
    uploadDate: '2026-02-05',
    fileSize: '5.6 MB',
    downloadAllowed: false,
    popular: false,
    views: 432,
  },
  {
    id: '6',
    title: 'MobileCT Pro Sales Deck Q1 2024',
    type: 'PPT',
    pptType: 'promo',
    primaryCategory: 'products',
    category: 'Mobile CT',
    modelCategory: 'MobileCT Pro',
    thumbnail: '',
    tags: ['Mobile CT', 'Sales', 'Q1 2024'],
    uploadDate: '2026-01-28',
    fileSize: '18.3 MB',
    downloadAllowed: true,
    popular: true,
    views: 1876,
  },
  {
    id: '7',
    title: 'RoboNav 3.0 Clinical Case Studies',
    type: 'PDF',
    primaryCategory: 'products',
    category: 'Robot Navigation',
    modelCategory: 'RoboNav 3.0',
    thumbnail: '',
    tags: ['Robot', 'Clinical', 'Case Study'],
    uploadDate: '2025-10-22',
    fileSize: '9.8 MB',
    downloadAllowed: true,
    popular: false,
    views: 789,
  },
  {
    id: '8',
    title: 'AlphaCT 968 Competitive Analysis Report',
    type: 'PDF',
    primaryCategory: 'products',
    category: 'CT Systems',
    modelCategory: 'AlphaCT 968',
    thumbnail: '',
    tags: ['AlphaCT', 'Analysis', 'Market'],
    uploadDate: '2025-09-18',
    fileSize: '6.1 MB',
    downloadAllowed: false,
    popular: false,
    views: 345,
  },
  {
    id: '9',
    title: 'Workstation Pro 4K Datasheet',
    type: 'PDF',
    primaryCategory: 'products',
    category: 'Workstation',
    modelCategory: 'Workstation Pro 4K',
    thumbnail: '',
    tags: ['Workstation', 'Imaging', 'Hardware'],
    uploadDate: '2026-02-10',
    fileSize: '4.3 MB',
    downloadAllowed: true,
    popular: false,
    views: 521,
  },
  {
    id: '10',
    title: 'OmegaCT One Launch Presentation 2024',
    type: 'PPT',
    pptType: 'promo',
    primaryCategory: 'products',
    category: 'CT Systems',
    modelCategory: 'OmegaCT One',
    thumbnail: '',
    tags: ['OmegaCT', 'Launch', 'New Product'],
    uploadDate: '2026-02-20',
    fileSize: '22.5 MB',
    downloadAllowed: true,
    popular: true,
    views: 3241,
  },
  {
    id: '11',
    title: 'Distributor Training Program Overview (PDF)',
    type: 'PPT',
    pptType: 'training',
    primaryCategory: 'training',
    category: 'Training',
    thumbnail: '',
    tags: ['Training', 'Distributor', 'Program'],
    uploadDate: '2025-10-15',
    fileSize: '15.2 MB',
    downloadAllowed: false,
    popular: false,
    views: 967,
  },
  {
    id: '12',
    title: 'PetCare CT V1 Veterinary Application Guide',
    type: 'PDF',
    primaryCategory: 'products',
    category: 'Veterinary',
    modelCategory: 'PetCare CT V1',
    thumbnail: '',
    tags: ['Petcare', 'Veterinary', 'Application'],
    uploadDate: '2025-08-12',
    fileSize: '7.9 MB',
    downloadAllowed: false,
    popular: false,
    views: 298,
  },
];

export const mockCategories = [
  { id: 'all', label: 'All Materials', count: 17 },
  { id: 'E-learning', label: 'E-learning', count: 5 },
  { id: 'CT Systems', label: 'CT Systems', count: 5 },
  { id: 'Software', label: 'Software', count: 2 },
  { id: 'Mobile CT', label: 'Mobile CT', count: 1 },
  { id: 'Robot Navigation', label: 'Robot Navigation', count: 1 },
  { id: 'Workstation', label: 'Workstation', count: 1 },
  { id: 'Training', label: 'Training', count: 1 },
  { id: 'Veterinary', label: 'Veterinary', count: 1 },
];

export const mockUser = {
  id: 'u001',
  name: 'James Wilson',
  email: 'admin@sinovision.com',
  company: 'Sinovision',
  region: 'Europe',
  status: 'active' as const,
  accountType: 'Admin',
  memberSince: '2022-06-01',
  expiryDate: '2027-06-30',
  avatar: 'JW',
};
